// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme-preview[data-v-77dab9c3] {\n  height: 50px;\n  width: 100px;\n  border-radius: 4px;\n  background-size: cover;\n  border: 1px solid #DCDFE6;\n}", ""]);
// Exports
module.exports = exports;
